module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/web3-eth/~/websocket/lib/version.js
// module id = 1937
// module chunks = 0 1 3